module.exports = __webpack_public_path__ + "img/nfpoa-tela02_corte.1b0ab61a.png";